import React from 'react';
import { useSignIn, useClerk } from '@clerk/clerk-react';
// Map of allowed test users to their passwords (dev-only)
const TEST_USER_PASSWORDS = {
    'test@fluid-form.ai': 'f42yc1GOrZ4ETLW4F@ea'
};
const isAllowedTestHost = (() => {
    const host = window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1' || host === 'dev.app.fluid-form.ai' || host === 'fluidweb-dev.web.app';
})();
const testUserEmailParam = (() => {
    try {
        const params = new URLSearchParams(window.location.search);
        return params.get('useTestUser');
    }
    catch {
        return null;
    }
})();
export const shouldBypassTestRedirect = Boolean(isAllowedTestHost && testUserEmailParam && TEST_USER_PASSWORDS[testUserEmailParam]);
export function TestUserAutoSignIn() {
    const { isLoaded, signIn } = useSignIn();
    const { setActive } = useClerk();
    const attemptedRef = React.useRef(false);
    React.useEffect(() => {
        const email = testUserEmailParam || '';
        if (!isAllowedTestHost || !email || !TEST_USER_PASSWORDS[email])
            return;
        if (!isLoaded || attemptedRef.current)
            return;
        attemptedRef.current = true;
        (async () => {
            try {
                const attempt = await signIn.create({ identifier: email, password: TEST_USER_PASSWORDS[email] });
                if (attempt?.status === 'complete' && attempt?.createdSessionId) {
                    await setActive({ session: attempt.createdSessionId });
                    // Clean query param to avoid repeated attempts
                    const url = new URL(window.location.href);
                    url.searchParams.delete('useTestUser');
                    window.history.replaceState({}, '', url.toString());
                    //reload to homepage
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 200);
                }
            }
            catch (err) {
                console.warn('Test user auto sign-in failed', err);
            }
        })();
    }, [isLoaded, signIn, setActive]);
    return null;
}
